export { CurrencyConverterPageTemplate } from "./CurrencyConverterPageTemplate";
export { CurrencyConverterPageTemplateOld } from "./CurrencyConverterPageTemplateOld";
